import { create } from 'zustand';
import { ObtFrontierUserContactModel } from 'src/globalModels/ObtFrontierUserContactModel';

interface ProfileStore {
  users: ObtFrontierUserContactModel[] | undefined;
  selectedUserId: number | undefined;
  setUsers: (users: ObtFrontierUserContactModel[]) => void;
  setSelectedUserId: (id: number) => void;
  clear: () => void;
}

export const useProfileStore = create<ProfileStore>((set) => ({
  users: undefined,
  selectedUserId: undefined,
  setUsers: (users) => set({ users }),
  setSelectedUserId: (id) => set({ selectedUserId: id }),
  clear: () => set({ users: undefined, selectedUserId: undefined })
}));
